import { debounce } from 'debounce';
import { useCallback } from 'react';
import { defaultDebounceInterval } from '../constants/debounce';
/**
 * Returns a debounced version of the asynchronous callback.
 *
 * @param callback the asynchronous callback that needs debouncing.
 * @param interval the debounce interval. If not provided, defaults to 750.
 */
export const useDebounceAsyncCallback = (callback, interval) => {
    const debounceInterval = interval !== null && interval !== void 0 ? interval : defaultDebounceInterval;
    return useCallback((value) => debounce(() => callback(value), debounceInterval), [debounceInterval, callback]);
};
//# sourceMappingURL=use-debounce-async-callback.js.map